import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';
import type {
  BillingStartSubscriptionRequest,
  BillingStartSubscriptionResponse,
} from '@kawai/shared';
import { callBillingStartSubscription } from '../api/billingStartSubscription.js';

/**
 * TP-22: `billingStartSubscription` Callable を呼ぶ React Query mutation hook。
 *
 * 成功時は `['tenants']` クエリを invalidate して BillingPage / TenantsListPage を即座に
 * 再取得させる（billingStatus: initial_paid → active の即時反映）。
 */
export function useBillingStartSubscription(): UseMutationResult<
  BillingStartSubscriptionResponse,
  Error,
  BillingStartSubscriptionRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: BillingStartSubscriptionRequest) =>
      callBillingStartSubscription(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    },
  });
}
